export const loTrinh = {
  banDo: {
    title: 'Delivery map',
    subtitle: 'Orders to deliver by delivery deadline',
    filter: {
      hanGiao: 'Delivery deadline',
      hanGiaoTu: 'From',
      hanGiaoDen: 'To',
      loaiGiao: 'Delivery type',
      trangThai: 'Order status',
      search: 'Invoice, customer, phone…',
      xem: 'View',
      loaiGiaoTatCa: 'All',
      loaiGiaoTuGiao: 'Own shipper',
      loaiGiaoHang: 'Carrier',
      tatCaTrangThai: 'All statuses',
      timKiem: 'Search',
      hinhThucTrangThai: 'Delivery type & status',
      sapXep: 'Sort',
      sapXepTheo: 'Sort by',
      khoVatLy: 'Physical warehouse',
      khoVatLyTatCa: 'All physical warehouses',
      khoVatLyEmpty: 'No physical warehouse',
    },
    sapXep: {
      hanGiaoTang: 'Earliest deadline',
      hanGiaoGiam: 'Latest deadline',
      canGiam: 'Heaviest',
      khoiGiam: 'Largest volume',
      kienGiam: 'Most packages',
      maDon: 'Invoice code',
      khachHang: 'Customer name (A–Z)',
    },
    preset: {
      den3hToi: 'Up to next 3 hours',
      homNay: 'Today',
      ngayMai: 'Tomorrow',
      homNayVaMai: 'Today and tomorrow',
      tuyChon: 'Custom',
    },
    nhomTrangThai: {
      moi: 'New',
      xuLyKho: 'In warehouse processing',
      dieuPhoi: 'Awaiting / dispatching',
      giaoHang: 'Awaiting / delivering',
      giaoLai: 'Failed / redelivery',
    },
    thamSo: {
      title: 'Active filters',
      hanGiao: 'Deadline',
      loaiGiao: 'Type',
      trangThai: 'Status',
      search: 'Keyword',
      mucHan: 'Urgency',
      ketQua: '{don} orders · {diem} stops',
    },
    donVi: {
      kg: 'kg',
      kien: 'pkg',
      m3: 'm³',
      don: 'orders',
    },
    nhan: {
      an: 'Dots',
      anMo: 'Dots only — hover to see label',
      gon: 'Time',
      gonMo: 'Compact: deadline',
      diaChi: 'Address',
      diaChiMo: 'Customer + address',
      dayDu: 'Full',
      dayDuMo: 'Deadline + customer + address + weight / packages / volume',
    },
    veBanDau: 'Reset view',
    xoayBanDo: 'Rotate map 90° (currently {n}°)',
    nen: {
      sang: 'Light map',
      chiTiet: 'Detailed map',
    },
    tongHop: {
      soDon: '{n} orders',
      soDiem: '{n} stops',
      tongKg: '{n} kg',
      tongM3: '{n} m³',
      tongKien: '{n} packages',
      tongCod: 'COD {n}',
      nhanSoDon: 'Orders',
      nhanSoDiem: 'Stops',
      nhanTongKg: 'Total weight (kg)',
      nhanTongKien: 'Packages',
      nhanTongM3: 'Total volume (m³)',
      nhanTongCod: 'Total COD',
      thieuToaDo: '{n} orders without coordinates',
      biCatBot: 'Showing first {n} orders only — narrow the time range',
    },
    chuGiai: {
      title: 'Deadline',
      tatCa: 'All',
      quaHan: 'Overdue',
      trong2h: 'Within 2 hours',
      homNay: 'Later today',
      sauHomNay: 'From tomorrow',
      kho: 'Warehouse',
    },
    list: {
      empty: 'No orders in this deadline range',
      thieuToaDo: 'No coordinates',
      hangVanChuyen: 'Carrier',
    },
    don: {
      khachHang: 'Customer',
      nguoiNhan: 'Receiver',
      diaChi: 'Address',
      hanGiao: 'Deadline',
      khungGio: 'Receiving window',
      canKhoiKien: 'Weight / volume / packages',
      kichThuoc: 'Package size',
      tongTien: 'Total',
      cod: 'COD',
      dichVu: 'Service',
      doiTac: 'Delivered by',
      uuTien: 'Priority',
      hangHoa: 'Items',
      ghiChu: 'Note',
      xemChiTiet: 'View order',
      themMatHang: '+{n} more items',
      soDonTaiDiem: '{n} orders at this stop',
      quaHanPhut: 'Overdue {n}',
    },
    tab: {
      don: 'Orders',
      loTrinh: 'Route suggestion',
    },
    goiY: {
      khoXuatPhat: 'Depot',
      gioXuatPhat: 'Departure time',
      veKho: 'Return to depot',
      xe: 'Vehicles',
      quanLyXe: 'Manage vehicles',
      chuaCoXe: 'No vehicles yet — click "Manage vehicles" to add',
      chonTatCa: 'Select all',
      boChon: 'Clear',
      soXe: '{n} vehicles',
      caLam: 'Shift',
      suaThongSo: 'Edit',
      thuGon: 'Collapse',
      nut: 'Suggest routes ({n} orders)',
      dangTinh: 'Computing routes…',
      boQuaHang: 'Skipping {n} orders shipped by carriers',
      khongCoDon: 'No self-delivered orders in the current filter',
      phuongAn: 'Plan',
      mucTieu: {
        RE: 'Cheapest',
        IT_XE: 'Fewest vehicles',
        NHANH: 'Fastest',
        KHU_VUC: 'By area',
        CAN_BANG: 'Balanced',
        TU_CHINH: 'Edited',
      },
      cungKetQua: 'same as: {n}',
      canhBaoPa: '{n} trips need review',
      canhBao: {
        QUA_TAI_KG: 'Overweight',
        QUA_TAI_M3: 'Over volume',
        VUOT_SO_DIEM: 'Too many stops',
        VUOT_CA: 'Past shift end',
      },
      chinh: {
        doiXe: 'Change vehicle for this trip',
        doiSang: 'Switch to vehicle',
        doiCho: 'swap with its current trip',
        chuyenDon: 'Move order {n} to',
        chuyenMoi: 'new trip',
        boRa: 'Remove from trip',
        themVao: 'Add order {n} to vehicle',
        meo: 'Click an order code to move it / remove it',
        hoanTac: 'Undo',
        dangTinhLai: 'Recalculating…',
      },
      kpi: {
        km: 'Total km',
        thoiGian: 'Total time',
        chiPhi: 'Estimated cost',
        soXe: 'Vehicles',
        donTre: 'Late orders',
        khongXep: 'Unassigned',
      },
      chuyen: {
        xuatPhat: 'Depart {n}',
        ve: 'Back {n}',
        ketThuc: 'Done {n}',
        tai: 'Load',
        vuotCa: 'Exceeds shift',
        diem: '{n} stops',
        xemTrenBanDo: 'Show only this trip',
        hienTatCa: 'Show all trips',
      },
      tre: 'Late',
      khongXepTitle: 'Unassigned orders',
      lyDo: {
        THIEU_TOA_DO: 'Missing coordinates',
        VUOT_TAI: 'Exceeds largest vehicle',
        KHONG_DU_XE: 'Not enough vehicles / shift time',
        BO_RA: 'Not assigned',
      },
      thongKe: 'Distances: {cache} pairs from cache, {moi} newly computed ({req} requests), {uoc} estimated · {ms} ms',
      nguon: {
        OSRM: 'Real road network (OSRM)',
        UOC_LUONG: 'Straight-line estimate — OSRM not enabled',
        KET_HOP: 'Partly estimated — OSRM missing data',
      },
      solver: {
        VROOM: 'VROOM',
        NOI_BO: 'Built-in solver',
      },
      lamMoi: 'Recompute',
      dong: 'Close result',
      phut: '{n} min',
      gioPhut: '{h} h {m} min',
    },
    xe: {
      title: 'Delivery vehicles',
      them: 'Add vehicle',
      sua: 'Edit vehicle',
      xoa: 'Delete vehicle',
      xacNhanXoa: 'Delete vehicle "{n}"?',
      daLuu: 'Vehicle saved',
      daXoa: 'Vehicle deleted',
      ten: 'Name',
      bienSo: 'Plate number',
      loaiXe: 'Type',
      taiTrongKg: 'Capacity (kg)',
      theTichM3: 'Cargo volume (m³)',
      theTichMo: 'Leave empty = unlimited',
      soDiemToiDa: 'Max stops / trip',
      gioBatDau: 'Shift start',
      gioKetThuc: 'Back before',
      phiCoDinh: 'Fixed cost / trip',
      phiMoiKm: 'Cost / km',
      phiMoiGio: 'Cost / hour',
      phiMo: 'Used to compare plans — empty uses defaults 5,000/km, 50,000/hour',
      kho: 'Default depot',
      khoTheoForm: 'Use depot chosen when suggesting',
      tenTaiXe: 'Driver',
      dienThoaiTaiXe: 'Driver phone',
      ghiChu: 'Note',
      dangHoatDong: 'Active',
      ngungHoatDong: 'Inactive',
      trong: 'No vehicles yet',
      luu: 'Save',
      huy: 'Cancel',
      batBuoc: 'Required',
    },
  },
}
